import { MathUtils } from '../MathUtils';
const numberFormatters = new Map();
const numberFormattersWithoutZeroes = new Map();
function getNumberFormatter(point) {
    if (numberFormatters.has(point) === false) {
        const numberFormatter = new Intl.NumberFormat(undefined, {
            minimumFractionDigits: point,
            maximumFractionDigits: point
        });
        numberFormatters.set(point, numberFormatter);
    }
    return numberFormatters.get(point);
}
function getNumberFormatWithoutZeroes(point) {
    if (numberFormattersWithoutZeroes.has(point) === false) {
        const numberFormatter = new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: point
        });
        numberFormattersWithoutZeroes.set(point, numberFormatter);
    }
    return numberFormattersWithoutZeroes.get(point);
}
function isCorrectValues(value, precision) {
    return isFinite(value) && !isNaN(value) && isFinite(precision) && !isNaN(precision);
}
export function formatTruncate(value, precision) {
    if (isCorrectValues(value, precision) === false) {
        return '';
    }
    const formatter = getNumberFormatter(precision);
    return formatter.format(MathUtils.TruncateDouble(value, precision));
}
export function formatRound(value, precision) {
    if (isCorrectValues(value, precision) === false) {
        return '';
    }
    const formatter = getNumberFormatter(precision);
    return formatter.format(value);
}
export function formatTruncateWithoutZeroes(value, precision) {
    if (isCorrectValues(value, precision) === false) {
        return '';
    }
    const formatter = getNumberFormatWithoutZeroes(precision);
    return formatter.format(MathUtils.TruncateDouble(value, precision));
}
export function formatRoundWithoutZeroes(value, precision) {
    if (isCorrectValues(value, precision) === false) {
        return '';
    }
    const formatter = getNumberFormatWithoutZeroes(precision);
    return formatter.format(value);
}
